import React from 'react';
import ReactApexChart from 'react-apexcharts';

const UserDonutChart = ({ second_chart_data }) => {
    // Extract data from the second_chart_data prop
    const active_users = second_chart_data?.active_users;
    const inactive_users = second_chart_data?.inactive_users;

    const totalUsers = active_users?.count + inactive_users?.count;
    const activePercentage = active_users?.percentage;
    const inactivePercentage = inactive_users?.percentage;

    // Prepare chart options and series
    const basicDonutChartOptions = {
        chart: {
            type: 'donut',
        },
        labels: ['Active Users', 'Inactive Users'],
        colors: ['#34D399', '#F87171'], // Green for Active, Red for Inactive
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
    };

    const basicDonutChartSeries = [active_users?.count, inactive_users?.count];

    return (
        <div className="card h-100 p-0">
            <div className="card-body p-24 text-center d-flex flex-wrap align-items-start gap-5 justify-content-center">
                <div className="position-relative">
                    <ReactApexChart
                        id="basicDonutChart"
                        className="w-auto d-inline-block"
                        options={basicDonutChartOptions}
                        series={basicDonutChartSeries}
                        type="donut"
                        height={190}
                    />
                    <div className="position-absolute start-50 top-50 translate-middle">
                        <span className="text-md text-secondary-light fw-medium">
                            Total Value
                        </span>
                        <h4 className="mb-0">{totalUsers}</h4>
                    </div>
                </div>
                <div className="max-w-290-px w-100">
                    <div className="d-flex align-items-center justify-content-between gap-12 border pb-12 mb-12 border-end-0 border-top-0 border-start-0">
                        <span className="text-primary-light fw-medium text-sm">Label</span>
                        <span className="text-primary-light fw-medium text-sm">Value</span>
                        <span className="text-primary-light fw-medium text-sm">%</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-12 mb-12">
                        <span className="text-primary-light fw-medium text-sm d-flex align-items-center gap-12">
                            <span className="w-12-px h-12-px bg-success-600 rounded-circle" />
                            Active Users
                        </span>
                        <span className="text-primary-light fw-medium text-sm">
                            {active_users?.count}
                        </span>
                        <span className="text-primary-light fw-medium text-sm">
                            {activePercentage}%
                        </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-12 mb-12">
                        <span className="text-primary-light fw-medium text-sm d-flex align-items-center gap-12">
                            <span className="w-12-px h-12-px bg-danger rounded-circle" />
                            Inactive Users
                        </span>
                        <span className="text-primary-light fw-medium text-sm">
                            {inactive_users?.count}
                        </span>
                        <span className="text-primary-light fw-medium text-sm">
                            {inactivePercentage}%
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDonutChart;
